import { CellContext, ColumnDef } from '@global-engineering-shared/gweb-material-types';

import useStyles from 'features/DataManagement/components/DataManagementTable/components/DataManagementTableColumns/DataManagementTableColumns.styles';
import RowMenuItem from 'features/DataManagement/components/RowMenuItem/RowMenuItem';
import { CurrentUploadedFile } from 'features/DataManagement/data/CurrentUploadedFile';
import { formatFileType, splitFormattedDateTime } from 'utils/formatColumns';

type CurrentUploadedFileWithStatus = CurrentUploadedFile & {
  uploadInProgress: boolean;
};

const useDataManagementTableColumns = (): ColumnDef<CurrentUploadedFileWithStatus>[] => {
  const classes = useStyles();
  return [
    {
      id: 'fileType',
      header: 'DATA TYPE',
      accessorKey: 'fileType',
      size: 600,
      meta: {
        getHeadCellProps: () => ({ className: classes.fileTypeCell }),
        getBodyCellProps: () => ({ className: classes.fileTypeCell }),
      },
      cell: (context) => formatFileType(context.getValue() as string),
    },
    {
      id: 'lastModifiedTime',
      header: 'LAST MODIFIED',
      accessorKey: 'lastModifiedTime',
      size: 200,
      meta: {
        getHeadCellProps: () => ({
          className: classes.lastModifiedHeadCell,
          align: 'right',
        }),
        getBodyCellProps: () => ({ className: classes.lastModifiedBodyCell }),
      },
      cell: ({ getValue }: CellContext<CurrentUploadedFileWithStatus, unknown>) => {
        const isoString = getValue() as string;
        if (!isoString) {
          return (
            <>
              <strong>N/A</strong>
            </>
          );
        }
        const { date, time } = splitFormattedDateTime(isoString);
        return (
          <>
            <strong>{date}</strong>, {time}
          </>
        );
      },
    },
    {
      id: 'action',
      size: 1,
      meta: {
        enableColumnActions: false,
        getBodyCellProps: () => ({ className: classes.actionCell }),
      },
      cell: ({ row }: CellContext<CurrentUploadedFileWithStatus, unknown>) => (
        <RowMenuItem
          uploadInProgress={row.original.uploadInProgress}
          dataType={row.original.fileType}
          canDownload={row.original.lastModifiedTime != null}
        />
      ),
    },
  ];
};

export default useDataManagementTableColumns;
